function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import calendar from "../../assets/icons/calendar.svg";
import checkGreen from "../../assets/icons/check-green.svg";
import checkboxIcon from "../../assets/icons/check.svg";
import chevronL from "../../assets/icons/chevron-l.svg";
import chevronMInactive from "../../assets/icons/chevron-m-inactive.svg";
import chevronM from "../../assets/icons/chevron-m.svg";
import chevronS from "../../assets/icons/chevron-s.svg";
import closeL from "../../assets/icons/close-l.svg";
import closeM from "../../assets/icons/close-m.svg";
import companyProfile from "../../assets/icons/company-profile.svg";
import download from "../../assets/icons/download.svg";
import envelope from "../../assets/icons/envelope.svg";
import eye from "../../assets/icons/eye.svg";
import individualProfile from "../../assets/icons/individual-profile.svg";
import logout from "../../assets/icons/logout.svg";
import menuMoreM from "../../assets/icons/menu-more-m.svg";
import searchL from "../../assets/icons/search-l.svg";
import searchM from "../../assets/icons/search-m.svg";
import settings from "../../assets/icons/settings.svg";
import tooltipArrow from "../../assets/icons/tooltip-arrow.svg";
import * as mVariables from "./mVariables";
var borders = {
  radius: '0.1875rem',
  width: {
    base: '0.0625rem',
    bigger: '0.125rem'
  }
};
var icons = {
  size: {
    extraLarge: '2rem',
    extraLargePlus: '2.25rem',
    large: '1.5rem',
    medium: '1rem',
    semiLarge: '1.75rem',
    small: '0.75rem'
  },
  svg: {
    calendar: calendar,
    checkGreen: checkGreen,
    checkboxIcon: checkboxIcon,
    chevronL: chevronL,
    chevronM: chevronM,
    chevronMInactive: chevronMInactive,
    chevronS: chevronS,
    closeL: closeL,
    closeM: closeM,
    companyProfile: companyProfile,
    download: download,
    envelope: envelope,
    eye: eye,
    individualProfile: individualProfile,
    logout: logout,
    menuMoreM: menuMoreM,
    searchL: searchL,
    searchM: searchM,
    settings: settings,
    tooltipArrow: tooltipArrow
  }
};
var appLayout = {
  stripColors: {
    stripColor1: '#7dae20',
    stripColor2: '#f8b102',
    stripColor3: '#305769',
    stripColor4: '#008600',
    stripColor5: '#d1d800',
    stripColor6: '#201c17'
  },
  width: '1600px'
};
var fonts = {
  size: {
    base: '1rem',
    bigger0: '1.125rem',
    bigger1: '1.25rem',
    bigger2: '1.625rem',
    bigger3: '2rem',
    bigger4: '2.1875rem',
    bigger5: '21.5625rem',
    bigger6: '3.75rem',
    root: '16px',
    smaller0: '0.875rem',
    smaller1: '0.75rem',
    smaller2: '0.675rem',
    smaller3: '0.5625rem'
  },
  weight: {
    bold: 700,
    extraBold: 800,
    extraLight: 200,
    heavy: 900,
    light: 300,
    medium: 500,
    regular: 400,
    semiBold: 600,
    thin: 100
  }
};
var breakpoints = {
  lg: 992,
  md: 768,
  xlg: 1356
};
var customBreakpoints = {
  vlg: 1296
};
var customColors = {
  azure: '#2F6DAC',
  leadingColor: {
    base: mVariables.colors.red,
    dark: mVariables.colors.darkRed,
    mid: mVariables.colors.midRed
  },
  lightBlue: '#53a9d3',
  lightNavy: '#0088ca',
  statusGrey: '#6e6c6e'
};
var list = {
  row: {
    height: {
      base: '2.5rem',
      bigger: '3.5rem'
    }
  }
};
var button = {
  horizontalPadding: '1.0625rem'
};
export var variables = _objectSpread({}, mVariables, {
  appLayout: appLayout,
  borders: borders,
  breakpoints: breakpoints,
  button: button,
  customBreakpoints: customBreakpoints,
  customColors: customColors,
  fonts: fonts,
  icons: icons,
  list: list
});